var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.showFloatingEl)?_c('div',{ref:"floating",staticClass:"floating-form",style:(_setup.floatingStyles)},[_vm._t("default",null,{"onSubmit":_setup.handleComplete,"dispatch":_setup.dispatch,"graphic":_setup.graphic})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }